import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Box } from "@mui/material";

import { categoryValidationRules } from "../../../pages/library/category/validation";
import { ActionButton, FormDialog, InputField } from "../../v3";
import { FinanceService } from "../../../services";

export const AddEditCategory = ({ open, onClose, categoryId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [categoryDetails, setCategoryDetails] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    if (open && categoryId) {
      fetchData(categoryId);
    } else {
      setCategoryDetails({
        name: "",
        description: "",
      });
    }
    setErrors({});
  }, [open, categoryId]);

  const fetchData = async (categoryId) => {
    try {
      const response = await FinanceService.getCategoryById(categoryId);
      setCategoryDetails({
        name: response?.data?.name || "",
        description: response?.data?.description || "",
      });
    } catch (error) {
      toast.error("Failed to fetch category details");
      console.log("🚀 ~ fetchData ~ error:", error);
    }
  };

  const handleClearForm = () => {
    setCategoryDetails({
      name: "",
      description: "",
    });
  };

  const updateDetailsState = (event) => {
    let { name, value } = event.target;
    if (name === "name") {
      value = value.trim().toUpperCase(); // TODO: restrict numbers only allow capital letters, underscores ( _ ) and hyphens (-)
    }
    setCategoryDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleCloseModal = () => {
    handleClearForm();
    setErrors({});
    onClose();
  };

  const handleSaveCategory = async () => {
    setErrors({});
    const errors = categoryValidationRules(categoryDetails);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    try {
      setLoading(true);
      let categoryData = null;
      if (categoryId) {
        categoryData = await FinanceService.updateCategory(categoryId, categoryDetails);
        toast.success("Category updated successfully");
      } else {
        categoryData = await FinanceService.createCategory({ ...categoryDetails, type: "EXPENSE" });
        toast.success("Category created");
      }
      if (onSuccess) onSuccess(categoryData.data);
    } catch (error) {
      let errorMessage = `Error ${categoryId ? "updating" : "adding"} Category`;
      const response = error?.response?.data;

      if (Array.isArray(response?.message)) {
        errorMessage = response.message.join(", ");
      } else if (typeof response?.message === "string") {
        errorMessage = response.message;
      }

      toast.error(errorMessage);
      console.log("🚀 ~ handleSaveCategory ~ error:", error);
    } finally {
      setLoading(false);
      handleCloseModal();
    }
  };
  return (
    <FormDialog
      open={open}
      title={categoryId ? "Edit Category" : "Add Category"}
      actions={
        <>
          <ActionButton buttonText="Cancel" onButtonClick={handleCloseModal} variant="outlined" />
          <ActionButton buttonText="Save" onButtonClick={handleSaveCategory} disabled={loading} />
        </>
      }
    >
      <Box mt={1} width={500}>
        <Box className="fl gap-2">
          <InputField
            required
            label="Category Name"
            name="name"
            value={categoryDetails.name}
            onChange={updateDetailsState}
            error={!!errors.name}
            helperText={errors.name}
            style={{ width: "100%" }}
          />
          <InputField
            label="Description"
            name="description"
            value={categoryDetails.description}
            onChange={updateDetailsState}
            error={!!errors.description}
            helperText={errors.description}
            style={{ width: "100%" }}
          />
        </Box>
      </Box>
    </FormDialog>
  );
};
